<p>dashboard-all-chart works!</p>
<main [class]="theme">
    <div class="chart-col">
        <div style="top: 50px; left: 50px; right: 50px; bottom: 50px">
            <div>ngx-charts-bar-vertical</div>
            <ngx-charts-bar-vertical *ngIf="chartType === 'bar-vertical'" class="chart-container" [view]="view"
                [scheme]="colorScheme" [schemeType]="schemeType" [customColors]="customColors" [results]="single"
                [animations]="animations" [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis"
                [legend]="showLegend" [legendTitle]="legendTitle" [legendPosition]="legendPosition"
                [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [tooltipDisabled]="tooltipDisabled"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [showGridLines]="showGridLines"
                [barPadding]="barPadding" [roundDomains]="roundDomains" [roundEdges]="roundEdges"
                [yScaleMax]="yScaleMax" [noBarWhenZero]="noBarWhenZero" [showDataLabel]="showDataLabel"
                [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-bar-vertical>

            <!-- 
        *ngIf="chartType === 'bar-horizontal'"
        -->
            <div>ngx-charts-bar-horizontal</div>
            <ngx-charts-bar-horizontal class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="single" [animations]="animations" [gradient]="gradient"
                [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [legendTitle]="legendTitle"
                [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                [tooltipDisabled]="tooltipDisabled" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [showGridLines]="showGridLines" [barPadding]="barPadding" [roundDomains]="roundDomains"
                [roundEdges]="roundEdges" [xScaleMax]="xScaleMax" [noBarWhenZero]="noBarWhenZero"
                [showDataLabel]="showDataLabel" [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-bar-horizontal>
            <!-- 
        *ngIf="chartType === 'bar-vertical-2d'"
        -->
            <div>ngx-charts-bar-vertical-2d</div>
            <ngx-charts-bar-vertical-2d class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="multi" [animations]="animations" [gradient]="gradient"
                [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [legendTitle]="legendTitle"
                [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                [tooltipDisabled]="tooltipDisabled" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [showGridLines]="showGridLines" [barPadding]="barPadding" [groupPadding]="groupPadding"
                [roundDomains]="roundDomains" [roundEdges]="roundEdges" [yScaleMax]="yScaleMax"
                [noBarWhenZero]="noBarWhenZero" [showDataLabel]="showDataLabel" [trimXAxisTicks]="trimXAxisTicks"
                [trimYAxisTicks]="trimYAxisTicks" [rotateXAxisTicks]="rotateXAxisTicks"
                [maxXAxisTickLength]="maxXAxisTickLength" [maxYAxisTickLength]="maxYAxisTickLength"
                [wrapTicks]="wrapTicks" (select)="select($event)" (activate)="activate($event)"
                (deactivate)="deactivate($event)">
            </ngx-charts-bar-vertical-2d>

            <!-- 
        *ngIf="chartType === 'bar-horizontal-2d'"
        -->
            <div>ngx-charts-bar-horizontal-2d</div>
            <ngx-charts-bar-horizontal-2d class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="multi" [animations]="animations" [gradient]="gradient"
                [tooltipDisabled]="tooltipDisabled" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [showGridLines]="showGridLines" [barPadding]="barPadding" [groupPadding]="groupPadding"
                [roundDomains]="roundDomains" [roundEdges]="roundEdges" [xScaleMax]="xScaleMax"
                [noBarWhenZero]="noBarWhenZero" [showDataLabel]="showDataLabel" [trimXAxisTicks]="trimXAxisTicks"
                [trimYAxisTicks]="trimYAxisTicks" [rotateXAxisTicks]="rotateXAxisTicks"
                [maxXAxisTickLength]="maxXAxisTickLength" [maxYAxisTickLength]="maxYAxisTickLength"
                [wrapTicks]="wrapTicks" (select)="select($event)" (activate)="activate($event)"
                (deactivate)="deactivate($event)">
            </ngx-charts-bar-horizontal-2d>

            <!-- 
        *ngIf="chartType === 'bar-vertical-stacked'"
        -->
            <div>ngx-charts-bar-vertical-stacked</div>
            <ngx-charts-bar-vertical-stacked class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="multi" [animations]="animations" [gradient]="gradient"
                [tooltipDisabled]="tooltipDisabled" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [showGridLines]="showGridLines" [barPadding]="barPadding" [roundDomains]="roundDomains"
                [yScaleMax]="yScaleMax" [noBarWhenZero]="noBarWhenZero" [showDataLabel]="showDataLabel"
                [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-bar-vertical-stacked>

            <!-- 
        *ngIf="chartType === 'bar-horizontal-stacked'"
        -->
            <div>ngx-charts-bar-horizontal-stacked</div>
            <ngx-charts-bar-horizontal-stacked class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="multi" [animations]="animations" [gradient]="gradient"
                [tooltipDisabled]="tooltipDisabled" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [showGridLines]="showGridLines" [barPadding]="barPadding" [roundDomains]="roundDomains"
                [showDataLabel]="showDataLabel" [xScaleMax]="xScaleMax" [noBarWhenZero]="noBarWhenZero"
                [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-bar-horizontal-stacked>

            <!-- 
        *ngIf="chartType === 'bar-vertical-normalized'"
        -->
            <div>ngx-charts-bar-vertical-normalized</div>
            <ngx-charts-bar-vertical-normalized class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="multi" [animations]="animations" [gradient]="gradient"
                [tooltipDisabled]="tooltipDisabled" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [showGridLines]="showGridLines" [barPadding]="barPadding" [roundDomains]="roundDomains"
                [noBarWhenZero]="noBarWhenZero" [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-bar-vertical-normalized>

            <!-- 
        *ngIf="chartType === 'bar-horizontal-normalized'"
        -->
            <div>ngx-charts-bar-horizontal-normalized</div>
            <ngx-charts-bar-horizontal-normalized class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="multi" [animations]="animations" [gradient]="gradient"
                [tooltipDisabled]="tooltipDisabled" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [showGridLines]="showGridLines" [barPadding]="barPadding" [roundDomains]="roundDomains"
                [noBarWhenZero]="noBarWhenZero" [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-bar-horizontal-normalized>

            <!-- 
            *ngIf="chartType === 'pie-chart'"
        -->
            <div>ngx-charts-pie-chart</div>
            <ngx-charts-pie-chart class="chart-container" [view]="view" [scheme]="colorScheme" [results]="single"
                [animations]="animations" [legend]="showLegend" [legendTitle]="legendTitle"
                [legendPosition]="legendPosition" [explodeSlices]="explodeSlices" [labels]="showLabels"
                [doughnut]="doughnut" [arcWidth]="arcWidth" [gradient]="gradient" [tooltipDisabled]="tooltipDisabled"
                [tooltipText]="pieTooltipText" (dblclick)="dblclick($event)" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-pie-chart>

            <!-- 
            *ngIf="chartType === 'advanced-pie-chart'"
        -->
            <div>ngx-charts-advanced-pie-chart</div>
            <ngx-charts-advanced-pie-chart class="chart-container" [view]="view" [scheme]="colorScheme"
                [results]="single" [valueFormatting]="valueFormatting" [animations]="animations" [gradient]="gradient"
                [tooltipDisabled]="tooltipDisabled" [tooltipText]="pieTooltipText" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-advanced-pie-chart>

            <!-- 
            *ngIf="chartType === 'pie-grid'"
        -->
            <div>ngx-charts-pie-grid</div>
            <ngx-charts-pie-grid class="chart-container" [view]="view" [scheme]="colorScheme" [results]="single"
                [animations]="animations" [tooltipDisabled]="tooltipDisabled" [tooltipText]="pieTooltipText"
                (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-pie-grid>

            <!-- 
            *ngIf="chartType === 'line-chart'"
        -->
            <div>ngx-charts-line-chart</div>
            <ngx-charts-line-chart [view]="view" class="chart-container" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="dateDataWithOrWithoutRange" [animations]="animations"
                [legend]="showLegend" [legendTitle]="legendTitle" [legendPosition]="legendPosition"
                [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [autoScale]="autoScale" [xScaleMin]="xScaleMin" [xScaleMax]="xScaleMax" [yScaleMin]="yScaleMin"
                [yScaleMax]="yScaleMax" [timeline]="timeline" [showGridLines]="showGridLines" [curve]="curve"
                [rangeFillOpacity]="rangeFillOpacity" [roundDomains]="roundDomains" [tooltipDisabled]="tooltipDisabled"
                [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-line-chart>

            <!-- 
            *ngIf="chartType === 'polar-chart'"
        -->
            <div>ngx-charts-polar-chart</div>
            <ngx-charts-polar-chart [view]="view" class="chart-container" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="multi" [animations]="animations" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [gradient]="gradient" [xAxis]="showXAxis"
                [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [autoScale]="autoScale"
                [showGridLines]="showGridLines" [rangeFillOpacity]="rangeFillOpacity" [roundDomains]="roundDomains"
                [tooltipDisabled]="tooltipDisabled" [showSeriesOnHover]="showSeriesOnHover"
                [trimYAxisTicks]="trimYAxisTicks" [maxYAxisTickLength]="maxYAxisTickLength" [curve]="closedCurve"
                (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-polar-chart>

            <!-- 
            *ngIf="chartType === 'bubble-chart'"
        -->
            <div>ngx-charts-bubble-chart</div>
            <ngx-charts-bubble-chart [view]="view" class="chart-container" [results]="bubble" [animations]="animations"
                [showGridLines]="showGridLines" [legend]="showLegend" [legendTitle]="legendTitle"
                [legendPosition]="legendPosition" [xAxis]="showXAxis" [yAxis]="showYAxis"
                [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel" [autoScale]="autoScale" [xScaleMin]="xScaleMin" [xScaleMax]="xScaleMax"
                [yScaleMin]="yScaleMin" [yScaleMax]="yScaleMax" [scheme]="colorScheme" [schemeType]="schemeType"
                [roundDomains]="roundDomains" [tooltipDisabled]="tooltipDisabled" [minRadius]="minRadius"
                [maxRadius]="maxRadius" [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (activate)="activate($event)"
                (deactivate)="deactivate($event)" (select)="select($event)">
            </ngx-charts-bubble-chart>

            <!-- 
            *ngIf="chartType === 'area-chart'"
        -->
            <div>ngx-charts-area-chart</div>
            <ngx-charts-area-chart class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="dateData" [animations]="animations" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [gradient]="gradient" [xAxis]="showXAxis"
                [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [autoScale]="autoScale" [xScaleMin]="xScaleMin"
                [xScaleMax]="xScaleMax" [yScaleMin]="yScaleMin" [yScaleMax]="yScaleMax" [timeline]="timeline"
                [showGridLines]="showGridLines" [roundDomains]="roundDomains" [curve]="curve"
                [tooltipDisabled]="tooltipDisabled" [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-area-chart>

            <!-- 
            *ngIf="chartType === 'area-chart-stacked'"
        -->
            <div>ngx-charts-area-chart-stacked</div>
            <ngx-charts-area-chart-stacked class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="dateData" [animations]="animations" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [gradient]="gradient" [xAxis]="showXAxis"
                [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [timeline]="timeline" [xScaleMin]="xScaleMin"
                [xScaleMax]="xScaleMax" [yScaleMin]="yScaleMin" [yScaleMax]="yScaleMax" [showGridLines]="showGridLines"
                [roundDomains]="roundDomains" [tooltipDisabled]="tooltipDisabled" [curve]="curve"
                [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" [wrapTicks]="wrapTicks" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-area-chart-stacked>

            <!-- 
            *ngIf="chartType === 'area-chart-normalized'"
        -->
            <div>ngx-charts-area-chart-normalized</div>
            <ngx-charts-area-chart-normalized class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="dateData" [animations]="animations" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [gradient]="gradient" [xAxis]="showXAxis"
                [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [timeline]="timeline"
                [showGridLines]="showGridLines" [roundDomains]="roundDomains" [tooltipDisabled]="tooltipDisabled"
                [curve]="curve" [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [rotateXAxisTicks]="rotateXAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" (select)="select($event)" (activate)="activate($event)"
                (deactivate)="deactivate($event)">
            </ngx-charts-area-chart-normalized>

            <!-- 
            *ngIf="chartType === 'heat-map'"
        -->
            <div>ngx-charts-heat-map</div>
            <ngx-charts-heat-map class="chart-container" [min]="heatmapMin" [max]="heatmapMax" [view]="view"
                [scheme]="colorScheme" [results]="multi" [animations]="animations" [legend]="showLegend"
                [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                [innerPadding]="innerPadding" [tooltipDisabled]="tooltipDisabled" [trimXAxisTicks]="trimXAxisTicks"
                [trimYAxisTicks]="trimYAxisTicks" [rotateXAxisTicks]="rotateXAxisTicks"
                [maxXAxisTickLength]="maxXAxisTickLength" [maxYAxisTickLength]="maxYAxisTickLength"
                [wrapTicks]="wrapTicks" (select)="select($event)" (activate)="activate($event)"
                (deactivate)="deactivate($event)">
            </ngx-charts-heat-map>

            <!-- 
            *ngIf="chartType === 'calendar'"
        -->
            <div>ngx-charts-heat-map</div>
            <ngx-charts-heat-map class="chart-container" [view]="view" [scheme]="colorScheme" [results]="calendarData"
                [animations]="animations" [legend]="showLegend" [gradient]="gradient" [xAxis]="showXAxis"
                [yAxis]="showYAxis" [showXAxisLabel]="false" [showYAxisLabel]="false"
                [xAxisTickFormatting]="calendarAxisTickFormatting" [tooltipText]="calendarTooltipText"
                [innerPadding]="innerPadding" [tooltipDisabled]="tooltipDisabled" [trimXAxisTicks]="trimXAxisTicks"
                [trimYAxisTicks]="trimYAxisTicks" [rotateXAxisTicks]="rotateXAxisTicks"
                [maxXAxisTickLength]="maxXAxisTickLength" [maxYAxisTickLength]="maxYAxisTickLength"
                [wrapTicks]="wrapTicks" (select)="select($event)" (activate)="activate($event)"
                (deactivate)="deactivate($event)">
            </ngx-charts-heat-map>

            <!-- 
            *ngIf="chartType === 'tree-map'"
        -->
            <div>ngx-charts-tree-map</div>
            <ngx-charts-tree-map class="chart-container" [view]="view" [scheme]="colorScheme" [results]="single"
                [animations]="animations" [tooltipDisabled]="tooltipDisabled" [labelFormatting]="gdpLabelFormatting"
                [valueFormatting]="currencyFormatting" [gradient]="gradient" (select)="select($event)">
            </ngx-charts-tree-map>

            <!-- 
            *ngIf="chartType === 'number-card'"
        -->
            <div>ngx-charts-number-card</div>
            <ngx-charts-number-card class="chart-container" [view]="view" [scheme]="colorScheme" cardColor="#232837"
                emptyColor="#1e222e" [results]="single" [animations]="animations" (select)="select($event)">
            </ngx-charts-number-card>

            <!-- 
            *ngIf="chartType === 'box-plot'"
        -->
            <div>ngx-charts-box-chart</div>
            <ngx-charts-box-chart class="chart-container" [view]="view" [results]="boxData" [scheme]="colorScheme"
                [schemeType]="schemeType" [customColors]="customColors" [strokeColor]="strokeColor"
                [strokeWidth]="strokeWidth" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [tooltipDisabled]="tooltipDisabled" [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel" [showGridLines]="showGridLines" [roundDomains]="roundDomains"
                [roundEdges]="roundEdges" [gradient]="gradient" [animations]="animations"
                (legendLabelClick)="onLegendLabelClick($event)" (select)="select($event)" (activate)="activate($event)"
                (deactivate)="deactivate($event)">
            </ngx-charts-box-chart>

            <!-- 
            *ngIf="chartType === 'sankey'"
        -->
            <div>ngx-charts-sankey</div>
            <ngx-charts-sankey class="chart-container" [view]="view" [results]="sankeyData" [scheme]="colorScheme"
                [schemeType]="schemeType" [customColors]="customColors" [tooltipDisabled]="tooltipDisabled"
                [animations]="animations" [showLabels]="showLabels" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-sankey>

            <!-- 
            *ngIf="chartType === 'gauge'"
        -->
            <div>ngx-charts-gauge</div>
            <ngx-charts-gauge class="chart-container" [view]="view" [legend]="showLegend" [legendTitle]="legendTitle"
                [legendPosition]="legendPosition" [results]="single" [animations]="animations"
                [textValue]="gaugeTextValue" [scheme]="colorScheme" [min]="gaugeMin" [max]="gaugeMax"
                [units]="gaugeUnits" [angleSpan]="gaugeAngleSpan" [startAngle]="gaugeStartAngle"
                [showAxis]="gaugeShowAxis" [bigSegments]="gaugeLargeSegments" [smallSegments]="gaugeSmallSegments"
                [margin]="margin ? [marginTop, marginRight, marginBottom, marginLeft] : [0, 0, 0, 0]"
                [tooltipDisabled]="tooltipDisabled" [showText]="showText" (select)="select($event)"
                (activate)="activate($event)" (deactivate)="deactivate($event)">
            </ngx-charts-gauge>

            <!-- 
            *ngIf="chartType === 'linear-gauge'"
        -->
            <div>ngx-charts-linear-gauge</div>
            <ngx-charts-linear-gauge class="chart-container" [view]="view" [scheme]="colorScheme"
                [animations]="animations" [min]="gaugeMin" [max]="gaugeMax" [value]="gaugeValue"
                [previousValue]="gaugePreviousValue" [units]="gaugeUnits" (select)="select($event)">
            </ngx-charts-linear-gauge>

            <!-- 
            *ngIf="chartType === 'percent-gauge'"
        -->
            <div>ngx-charts-percent-gauge</div>
            <ngx-charts-percent-gauge class="chart-container" [view]="view" [scheme]="colorScheme"
                [animations]="animations" [value]="gaugeValue" [target]="target" [max]="gaugeMax"
                [showLabel]="showLabel" label="Coverage" (select)="select($event)">
            </ngx-charts-percent-gauge>


            <div>
                <div>ngx-charts-line-chart</div>
                <ngx-charts-line-chart style="position: static; display: inline-block; transform: none" [view]="view"
                    class="chart-container" [scheme]="colorScheme" [schemeType]="schemeType" [results]="plotData"
                    [animations]="animations" [legend]="false" [legendTitle]="legendTitle"
                    [legendPosition]="legendPosition" [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis"
                    [showXAxisLabel]="false" [showYAxisLabel]="false" [xAxisLabel]="'angle'" [yAxisLabel]="'radius'"
                    [autoScale]="autoScale" [timeline]="timeline" [showGridLines]="showGridLines"
                    [curve]="curves['Cardinal']" [rangeFillOpacity]="rangeFillOpacity" [roundDomains]="roundDomains"
                    [tooltipDisabled]="tooltipDisabled" [trimXAxisTicks]="trimXAxisTicks"
                    [trimYAxisTicks]="trimYAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                    [maxYAxisTickLength]="maxYAxisTickLength" (select)="select($event)">
                </ngx-charts-line-chart>
                <p>ngx-charts-polar-chart</p>
                <ngx-charts-polar-chart style="position: static; display: inline-block; transform: none" [view]="view"
                    class="chart-container" [scheme]="colorScheme" [schemeType]="schemeType" [results]="plotData"
                    [animations]="animations" [legend]="false" [legendTitle]="legendTitle"
                    [legendPosition]="legendPosition" [gradient]="gradient" [xAxis]="false" [yAxis]="true"
                    [showXAxisLabel]="false" [showYAxisLabel]="false" [xAxisLabel]="'angle'" [yAxisLabel]="'radius'"
                    [autoScale]="autoScale" [showGridLines]="showGridLines" [rangeFillOpacity]="rangeFillOpacity"
                    [roundDomains]="roundDomains" [tooltipDisabled]="tooltipDisabled"
                    [showSeriesOnHover]="showSeriesOnHover" [curve]="curves['Cardinal Closed']"
                    [trimYAxisTicks]="trimYAxisTicks" [maxYAxisTickLength]="maxYAxisTickLength"
                    (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
                </ngx-charts-polar-chart>
            </div>
            <div class="chart-container" style="padding: 10px; border: 1px solid white">
                <h4 style="text-align: center">
                    <button class="btn btn-link" [class.active]="sumBy === 'Size'" (click)="treemapProcess('Size')">
                        By Size
                    </button>
                    <button class="btn btn-link" [class.active]="sumBy === 'Count'" (click)="treemapProcess('Count')">
                        By Count
                    </button>
                </h4>
                <div style="height: 17px; font-size: 12px">
                    <ng-container *ngFor="let item of treemapPath; let last = last">
                        <button class="btn btn-link" [class.active]="last" [disabled]="last"
                            (click)="treemapSelect(item)">
                            {{ item.name }} ({{ item.value }})
                        </button>
                        <span *ngIf="!last"> / </span>
                    </ng-container>
                </div>
                <ngx-charts-tree-map [view]="view" [scheme]="colorScheme" [results]="treemap" [animations]="animations"
                    [tooltipDisabled]="tooltipDisabled" [gradient]="gradient" (select)="treemapSelect($event)">
                </ngx-charts-tree-map>
            </div>
            <div class="chart-container" style="padding: 10px; border: 1px solid white">
                <div>
                    <span class="active">{{ getBubbleInteractiveTitle() }}</span>
                    <button *ngIf="bubbleShowDrillDownResetLink()" class="btn btn-link" style="float: right"
                        (click)="onClickResetBubbleInteractiveDrill()">
                        <span>Go Back</span>
                    </button>
                </div>

            </div>

            <div>ngx-charts-line-chart</div>
            <ngx-charts-line-chart [view]="view" class="chart-container" [scheme]="colorScheme"
                [schemeType]="schemeType" [results]="multi" [animations]="animations" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [gradient]="gradient" [xAxis]="showXAxis"
                [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [autoScale]="autoScale" [timeline]="timeline"
                [showGridLines]="showGridLines" [curve]="curve" [rangeFillOpacity]="rangeFillOpacity"
                [roundDomains]="roundDomains" [tooltipDisabled]="tooltipDisabled" [showRefLines]="showRefLines"
                [showRefLabels]="showRefLabels" [referenceLines]="refLines" [trimXAxisTicks]="trimXAxisTicks"
                [trimYAxisTicks]="trimYAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                [maxYAxisTickLength]="maxYAxisTickLength" (select)="select($event)" (activate)="activate($event)"
                (deactivate)="deactivate($event)">
            </ngx-charts-line-chart>

            <div>ngx-charts-bar-vertical</div>
            <ngx-charts-bar-vertical class="chart-container" [view]="view" [scheme]="colorScheme"
                [schemeType]="schemeType" [customColors]="customColors" [results]="single" [animations]="animations"
                [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [tooltipDisabled]="tooltipDisabled" [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel" [showGridLines]="showGridLines" [barPadding]="barPadding"
                [roundDomains]="roundDomains" [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
                [maxXAxisTickLength]="maxXAxisTickLength" [maxYAxisTickLength]="maxYAxisTickLength"
                (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
                <ng-template #tooltipTemplate let-model="model">
                    <h1>
                        {{ getFlag(model.name) }}
                    </h1>
                    <h2>{{ model.name }}: {{ model.value }}</h2>
                </ng-template>
            </ngx-charts-bar-vertical>

        </div>
        <div>ngx-charts-bar-vertical-stacked</div>
        <ngx-charts-bar-vertical-stacked class="chart-container" [view]="view" [scheme]="colorScheme"
            [schemeType]="schemeType" [results]="fiscalYearReport" [animations]="animations" [gradient]="gradient"
            [tooltipDisabled]="tooltipDisabled" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
            [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="'Fiscal Year Report'"
            [showGridLines]="showGridLines" [barPadding]="barPadding" [roundDomains]="roundDomains"
            [noBarWhenZero]="noBarWhenZero" [yScaleMax]="yScaleMax" [showDataLabel]="showDataLabel"
            [trimXAxisTicks]="trimXAxisTicks" [trimYAxisTicks]="trimYAxisTicks"
            [maxXAxisTickLength]="maxXAxisTickLength" [maxYAxisTickLength]="maxYAxisTickLength"
            (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
        </ngx-charts-bar-vertical-stacked>

        <div>ngx-charts-bar-horizontal-stacked</div>
        <ngx-charts-bar-horizontal-stacked class="chart-container" [view]="view" [scheme]="colorScheme"
            [schemeType]="schemeType" [results]="fiscalYearReport" [animations]="animations" [gradient]="gradient"
            [tooltipDisabled]="tooltipDisabled" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
            [legendTitle]="legendTitle" [legendPosition]="legendPosition" [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="'Fiscal Year Report'"
            [showGridLines]="showGridLines" [barPadding]="barPadding" [roundDomains]="roundDomains"
            [noBarWhenZero]="noBarWhenZero" [showDataLabel]="showDataLabel" [trimXAxisTicks]="trimXAxisTicks"
            [trimYAxisTicks]="trimYAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
            [maxYAxisTickLength]="maxYAxisTickLength" (select)="select($event)" (activate)="activate($event)"
            (deactivate)="deactivate($event)">
        </ngx-charts-bar-horizontal-stacked>
    </div>

</main>